import { useState, useEffect, useRef } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import Select, { components } from 'react-select';
import ReactQuill, { Quill } from 'react-quill';
import ImageResize from 'quill-image-resize-module-react';
import { ImageDrop } from 'quill-image-drop-module';
import QuillImageDropAndPaste from 'quill-image-drop-and-paste'
import TimePicker from 'react-time-picker';
import { Link } from "react-router-dom";
import { Controller } from "react-hook-form";
import { AiFillCheckCircle, AiOutlinePlus } from "react-icons/ai";
import { FaRegCircle } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import Swal from 'sweetalert2';
import { useSelector } from 'react-redux';
import classNames from "classnames";

// Custom Component
import ErrorText from '../../TextField/ErrorText';
import { PrimaryOutlineButton } from '../../Button';
import AgeGroup from './AgeGroup';
import TeamCategory from './TeamCategory';
import CustomDatePicker from '../../CustomDatePicker/CustomDatePicker';
import DatePickerWithYearAndMonth from '../../DatePickerWithYearAndMonth/DatePickerWithYearAndMonth';
import ErrorAlert from '../../Alert/ErrorAlert';

// Images
// import { Badminton, PickleBall, User, Users } from '../../../assets/images/svg';
import { Badminton, PickleBall, User ,Users} from '../../../assets/images/svg';

// Utils
import { detectMenEvent, detectWomenEvent, eventTypeList } from '../../../utils/helper';

// API Service
import { allSubOrganizerService } from '../../../service/subOrganizer.service';

// Redux-Functions
import { selectUser } from "../../../redux/userSlice";

Quill.register('modules/imageResize', ImageResize);
Quill.register('modules/imageDrop', ImageDrop);
Quill.register('modules/imageDropAndPaste', QuillImageDropAndPaste);

const TournamentForm = ({ register, control, watch, setValue, errors, individualEventsFields, individualEventsAppend, individualEventsRemove, teamEventsFields, teamEventsAppend }) => {
    const user = useSelector(selectUser);

    const registrationStartDateRef = useRef(null);
    const registrationEndDateRef = useRef(null);
    const tournamentStartDateRef = useRef(null);
    const tournamentEndDateRef = useRef(null);

    const [subOrganizerList, setSubOrganizerList] = useState([])


    const modules = {
        toolbar: [
            [
                'bold',
                'italic',
                'underline',
                'strike'
            ],
            [
                'blockquote',
                'code-block'
            ],
            [
                {
                    header: [
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        false
                    ]
                }
            ],
            [
                {
                    list: 'ordered'
                },
                {
                    list: 'bullet'
                }
            ],
            [
                {
                    script: 'sub'
                },
                {
                    script: 'super'
                }
            ],
            [
                {
                    indent: '-1'
                },
                {
                    indent: '+1'
                }
            ],
            [
                {
                    direction: 'rtl'
                }
            ],
            [
                {
                    color: []
                },
                {
                    background: []
                }
            ],
            [
                'link',
                'image',
                'video'
            ],
            [
                'clean'
            ]
        ],
        clipboard: {
            matchVisual: false
        },
        imageResize: {
            parchment: Quill.import('parchment'),
            modules: [
                'Resize',
                'DisplaySize',
                'Toolbar'
            ]
        },
        imageDrop: true,
        imageDropAndPaste: true
    };

    const formats = [
        'header',
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'strike',
        'blockquote',
        'list',
        'bullet',
        'indent',
        'link',
        'image',
        'video',
        'color',
        'align',
        'background',
        'direction',
        'code-block',
        'code'
    ];

    const watchSportsType = watch("sports_type")
    const watchCategoryType = watch("category_type")
    const watchNumberOfTeamEvent = watch("number_of_team_event")
    const allWatchedValues = watch({
        nest: true
    });

    /**
        * @function fetchSubOrganizerList
        * @params 
        * @description fetch the list of sub organizer
    */
    const fetchSubOrganizerList = async () => {
        try {
            const result = await allSubOrganizerService({
                paginate: 0,
                page: '',
                perPage: '',
                keyword: '',
                status: 1
            });
            if (result?.data?.status) {
                setSubOrganizerList(result?.data?.data?.organizations)
            } else {
                ErrorAlert(result?.response?.data?.message)
            }
        } catch (error) {
            ErrorAlert(error)
        }
    }

    useEffect(() => {
        if (user?.type === 'organizer') {
            fetchSubOrganizerList()
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (watchNumberOfTeamEvent) {
            if (allWatchedValues?.team_events?.length > 0) {
                if (parseInt(watchNumberOfTeamEvent) > allWatchedValues?.team_events?.length) {
                    const addEvent = Array(parseInt(watchNumberOfTeamEvent) - allWatchedValues?.team_events?.length).fill({
                        event_name: "",
                        number_of_participants: "",
                        price: "",
                        event_details: [
                            {
                                event_type: eventTypeList.find(event => !allWatchedValues?.team_events?.map(item => item?.event_type).includes(event?.value))?.value,
                                age_groups: [
                                    {
                                        age_group: "BELOW_AGE",
                                        age_value: "",
                                        number_of_males: "",
                                        number_of_females: "",
                                        is_disabled: true,
                                        allow_proffesional_players: false
                                    }
                                ]
                            }
                        ]
                    })
                    teamEventsAppend(addEvent)
                } else if (parseInt(watchNumberOfTeamEvent) < allWatchedValues?.team_events?.length) {
                    setValue('team_events', allWatchedValues?.team_events?.slice(0, watchNumberOfTeamEvent));
                }
            } else {
                const addEvent = Array(parseInt(watchNumberOfTeamEvent)).fill({
                    event_name: "",
                    number_of_participants: "",
                    price: "",
                    event_details: [
                        {
                            event_type: eventTypeList.find(event => !allWatchedValues?.team_events?.map(item => item?.event_type).includes(event?.value))?.value,
                            age_groups: [
                                {
                                    age_group: "BELOW_AGE",
                                    age_value: "",
                                    number_of_males: "",
                                    number_of_females: "",
                                    is_disabled: true,
                                    allow_proffesional_players: false
                                }
                            ]
                        }
                    ]
                })
                teamEventsAppend(addEvent)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchNumberOfTeamEvent])

    const reactSelectCustomStyle = {
        control: (baseStyles, state) => ({
            ...baseStyles,
            border: state.isFocused && "1px solid #FA5000",
            boxShadow: state.isFocused && "0px 0px 2px #FA5000",
            "&:hover": {
                border: "1px solid #FA5000",
                boxShadow: "0px 0px 2px #FA5000"
            }
        }),
        option: (styles, { isSelected }) => {
            return {
                ...styles,
                backgroundColor: isSelected ? '#FA5000' : 'white',
                "&:hover": {
                    backgroundColor: "#FA5000",
                    color: 'white'
                }
            }
        },
        dropdownIndicator: (provided) => ({
            ...provided,
            color: '#CCCCCC'
        }),
        indicatorSeparator: (provided) => ({
            ...provided,
            backgroundColor: '#CCCCCC'
        })
    }

    /**
        * @function SelectMenuButton
        * @params props
        * @description used for add button in select dropdown
    */
    const SelectMenuButton = (props) => {
        return <components.MenuList {...props}>
            {props.children}
            <div className='py-3 px-1'>
                <Link to='/sub-organizer' className='text-decoration-none'>
                    <div className='d-inline-block'>
                        <PrimaryOutlineButton className='rounded-pill px-2 py-1'>+ Sub Organizer</PrimaryOutlineButton>
                    </div>
                </Link>
            </div>
        </components.MenuList>
    }

    return <>
        <Form.Group className="my-4">
            <Form.Label className='fs-14 fw-500'>Select Sub Organizer</Form.Label>
            <Controller
                name={`organization_id`}
                control={control}
                render={({ field }) => (
                    <Select
                        styles={reactSelectCustomStyle}
                        placeholder='Select Sub Organizer'
                        components={{ MenuList: SelectMenuButton }}
                        options={subOrganizerList?.map((item) => {
                            return {
                                value: item?.id,
                                label: item?.name
                            }
                        })}
                        isMulti={true}
                        isSearchable={true}
                        {...field}
                    />
                )}
            />
        </Form.Group>

        <Form.Group className="my-4">
            <Form.Label className='fs-14 fw-500'>Tournament name</Form.Label>
            <Form.Control
                type="text"
                placeholder="Enter name here"
                {...register("name", {
                    required: "Tournament name is required"
                })}
            />
            {errors.name && <ErrorText>{errors.name.message}</ErrorText>}
        </Form.Group>

        <Form.Group className="mb-4">
            <Form.Label className='fs-14 fw-500'>Description</Form.Label>
            <Controller
                id='description'
                name={`description`}
                control={control}
                render={({ field }) => (
                    <ReactQuill
                        theme="snow"
                        value={field.value}
                        modules={modules}
                        formats={formats}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        ref={field.ref}
                        preserveWhitespace={true}
                    />
                )}
                rules={{
                    required: "Description is required"
                }}
            />
            {errors.description && <ErrorText>{errors.description.message}</ErrorText>}
        </Form.Group>

        <Form.Group className="mb-4">
            <Form.Label className='fs-14 fw-500'>Prizes</Form.Label>
            <Controller
                id='prizes'
                name={`prizes`}
                control={control}
                render={({ field }) => (
                    <ReactQuill
                        theme="snow"
                        value={field.value}
                        modules={modules}
                        formats={formats}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        ref={field.ref}
                        preserveWhitespace={true}
                    />
                )}
                rules={{
                    required: "Prizes is required"
                }}
            />
            {errors.prizes && <ErrorText>{errors.prizes.message}</ErrorText>}
        </Form.Group>

        <Form.Group className="mb-4">
            <Form.Label className='fs-14 fw-500'>Terms & Conditions</Form.Label>
            <Controller
                id='terms_and_condition'
                name={`terms_and_condition`}
                control={control}
                render={({ field }) => (
                    <ReactQuill
                        theme="snow"
                        value={field.value}
                        modules={modules}
                        formats={formats}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                        ref={field.ref}
                        preserveWhitespace={true}
                    />
                )}
                rules={{
                    required: "Terms & Conditions is required"
                }}
            />
            {errors.terms_and_condition && <ErrorText>{errors.terms_and_condition.message}</ErrorText>}
        </Form.Group>

        <Row className='mb-4'>
            <span className='fs-18 fw-600 mb-3'>Contact</span>
            <Col xs={6}>
                <Form.Group>
                    <Form.Label className='fs-14 fw-500'>Contact Person</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter name here"
                        {...register("contact", {
                            required: "Contact Person is required",
                        })}
                    />
                    {errors.contact && <ErrorText>{errors.contact.message}</ErrorText>}
                </Form.Group>
            </Col>
            <Col xs={6}>
                <Form.Group>
                    <Form.Label className='fs-14 fw-500'>Phone number</Form.Label>
                    <Form.Control
                        type="tel"
                        placeholder="Enter phone number here"
                        {...register("phone_number", {
                            required: "Phone number is required",
                            minLength: {
                                value: 9,
                                message: "Phone Number should be 9 digit minimum"
                            },
                            maxLength: {
                                value: 11,
                                message: "Phone Number should be 11 digit maximum"
                            }
                        })}
                    />
                    {errors.phone_number && <ErrorText>{errors.phone_number.message}</ErrorText>}
                </Form.Group>
            </Col>
        </Row>

        <Form.Group className="my-4">
            <Form.Label className='fs-14 fw-500'>Location</Form.Label>
            <Form.Control
                type="text"
                placeholder="Enter location here"
                {...register("address", {
                    required: "Location is required",
                })}
            />
            {errors.address && <ErrorText>{errors.address.message}</ErrorText>}
        </Form.Group>

        <div className='d-flex flex-column align-items-start mb-4'>
            <span className='fs-18 fw-600'>Type of Sports</span>
            <div className='d-flex flex-wrap align-items-start'>
                <Form.Check
                    className='sport-type ps-0'
                    type='radio'
                    label={<div role="button" className={classNames('d-flex flex-column align-items-center rounded py-2 px-3 mt-3 me-3', {
                        "text-light bg-primary": watchSportsType === "BADMINTON",
                        "text-primary": watchSportsType !== "BADMINTON",
                    })}>
                        <Badminton className='img-fluid mt-2 mb-2' />
                        <span>Badminton</span>
                    </div>}
                    id={`badminton`}
                    value="BADMINTON"
                    {...register("sports_type")}
                />
                <Form.Check
                    className='sport-type ps-0'
                    type='radio'
                    label={<div role="button" className={classNames('d-flex flex-column align-items-center rounded py-2 px-3 mt-3', {
                        "text-light bg-primary": watchSportsType === "PICKLEBALL",
                        "text-primary": watchSportsType !== "PICKLEBALL",
                    })}>
                        <PickleBall className='img-fluid mt-2 mb-2' />
                        <span>Pickleball</span>
                    </div>}
                    id={`pickleball`}
                    value="PICKLEBALL"
                    {...register("sports_type")}
                />
            </div>
        </div>

        <Row className='mb-4'>
            <span className='fs-18 fw-600 mb-3'>Categories</span>
            <div className='d-flex flex-wrap align-items-start'>
                <Form.Check
                    className='tournament-category me-5 ps-0'
                    type='checkbox'
                    label={<span role='button'>
                        {watchCategoryType?.includes("INDIVIDUAL") ?
                            <AiFillCheckCircle className='text-primary me-3' size={25} />
                            :
                            <FaRegCircle className='text-primary me-3' size={22} />
                        }
                        <User className='me-2' color={watchCategoryType?.includes("INDIVIDUAL") && '#FA5000'} />
                        Individuals Event
                    </span>}
                    id={`individuals-event`}
                    value="INDIVIDUAL"
                    {...register("category_type", {
                        validate: (value) =>
                            value.length > 0 || "At least one category must be selected"
                    })}
                />
                <div className="d-flex flex-column align-items-start">
                    <Form.Check
                        className='tournament-category ps-0'
                        type='checkbox'
                        label={<span role='button'>
                            {watchCategoryType?.includes("TEAM") ?
                                <AiFillCheckCircle className='text-primary me-3' size={25} />
                                :
                                <FaRegCircle className='text-primary me-3' size={22} />
                            }
                            <Users className='me-2' color={watchCategoryType?.includes("TEAM") && '#FA5000'} />
                            Team Event
                        </span>}
                        id={`team-event`}
                        value="TEAM"
                        {...register("category_type", {
                            validate: (value) =>
                                value.length > 0 || "At least one category must be selected"
                        })}
                    />
                    {watchCategoryType?.includes("TEAM") &&
                        <Form.Group>
                            <Form.Label className='fs-14 fw-500'>Number of Team Event</Form.Label>
                            <Form.Control
                                type="number"
                                {...register("number_of_team_event", {
                                    required: "Number of Team Event is required"
                                })}
                            />
                            {errors.number_of_team_event && <ErrorText>{errors.number_of_team_event.message}</ErrorText>}
                        </Form.Group>
                    }
                </div>
            </div>
            {errors.category_type && <ErrorText className='mt-2'>{errors.category_type.message}</ErrorText>}
        </Row>

        {watchCategoryType?.includes("INDIVIDUAL") &&
            <>
                <p className='fs-18 fw-bold mb-4'>Individual Event</p>

                {individualEventsFields?.length > 0 && individualEventsFields?.map((item, index) => {
                    return (
                        <div className='mt-3 p-3 border bg-gray rounded' key={item.id}>
                            <div className='d-flex justify-content-between align-items-center'>
                                <span className='fw-500 text-dark'>Categories</span>
                                {individualEventsFields?.length > 1 && <IoMdClose role='button' color='red' size={20} onClick={() => {
                                    Swal.fire({
                                        title: "Are you sure ?",
                                        text: "You won't be able to revert this!",
                                        icon: "warning",
                                        showCancelButton: true,
                                        showCloseButton: true,
                                        confirmButtonColor: "#FA5000",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes, Delete It!",
                                        reverseButtons: true,
                                        customClass: {
                                            container: 'delete-swal-container',
                                            title: 'fs-20 mb-3'
                                        }
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            individualEventsRemove(index)
                                        }
                                    });
                                }} />}
                            </div>
                            <div className='d-flex flex-wrap align-items-center'>
                                {eventTypeList?.length > 0 && eventTypeList?.map((eventTypeItem, eventTypeIndex) => {
                                    return <Form.Group key={`event${index}-${eventTypeIndex}`}>
                                        <Form.Check
                                            className='event-type ps-0 mt-3 me-2'
                                            type='radio'
                                            label={<span role='button' className={classNames('p-2', {
                                                'bg-primary text-light rounded': allWatchedValues?.individual_events[index]?.event_type === eventTypeItem?.value,
                                                'bg-event rounded': allWatchedValues?.individual_events[index]?.event_type !== eventTypeItem?.value
                                            })}>
                                                {detectMenEvent({
                                                    event: eventTypeItem?.value,
                                                    color: allWatchedValues?.individual_events[index]?.event_type === eventTypeItem?.value && 'white',
                                                    className: 'me-2'
                                                })}
                                                {detectWomenEvent({
                                                    event: eventTypeItem?.value,
                                                    color: allWatchedValues?.individual_events[index]?.event_type === eventTypeItem?.value && 'white',
                                                    className: 'me-2'
                                                })}
                                                {eventTypeItem?.label}
                                            </span>}
                                            id={`${eventTypeItem?.value?.toLowerCase()}${index}`}
                                            value={eventTypeItem?.value}
                                            {...register(`individual_events[${index}].event_type`)}
                                            disabled={allWatchedValues?.individual_events?.find((eventItem, eventIndex) => eventItem.event_type === eventTypeItem?.value && index !== eventIndex)}
                                        />
                                    </Form.Group>
                                })}
                            </div>
                            <AgeGroup
                                nestIndex={index}
                                allWatchedValues={allWatchedValues}
                                {...{ control, register, errors ,watch }}
                            />
                        </div>
                    );
                })}

                <div role='button' className='d-flex justify-content-center align-items-center mt-3 border rounded py-2' onClick={() => {
                    if (allWatchedValues?.individual_events?.length >= eventTypeList?.length) {
                        ErrorAlert(`You can't add more than ${eventTypeList?.length} event`)
                    } else {
                        individualEventsAppend({
                            event_type: eventTypeList.find(event => !allWatchedValues?.individual_events?.map(item => item?.event_type).includes(event?.value))?.value,
                            age_groups: [
                                {
                                    age_group: "BELOW_AGE",
                                    age_value: "",
                                    price: "",
                                    number_of_males: "",
                                    number_of_females: "",
                                    allowed_registrations: "",
                                    is_disabled: true,
                                    allow_proffesional_players: false
                                }
                            ]
                        })
                    }
                }}>
                    <AiOutlinePlus className='me-2' size={25} />
                    <span className='fs-14 fw-600 text-secondary'>Add more Categories</span>
                </div>
            </>
        }

        {watchCategoryType?.includes("TEAM") && parseInt(watchNumberOfTeamEvent) > 0 &&
            <div className='mt-3'>
                <p className='fs-18 fw-bold mb-4'>Team Event</p>

                {teamEventsFields?.length > 0 && teamEventsFields?.map((item, index) => {
                    return (
                        <div key={item.id}>
                            <p className='mt-3 mb-0'>Team Event {index + 1}</p>
                            <div className='mt-3 p-3 border bg-gray rounded'>
                                <Form.Group>
                                    <Form.Label className='fs-14 fw-500'>Name of team event {index + 1}</Form.Label>
                                    <Controller
                                        control={control}
                                        name={`team_events[${index}].event_name`}
                                        render={({ field }) => {
                                            return (
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Enter name here"
                                                    {...field}
                                                />
                                            )
                                        }}
                                        rules={{
                                            required: "Team Name is required"
                                        }}
                                    />
                                    {errors?.team_events?.length > 0 && errors?.team_events[index]?.event_name && <ErrorText>{errors?.team_events[index]?.event_name?.message}</ErrorText>}
                                </Form.Group>
                            </div>
                            <Row className='mt-3'>
                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className='fs-14 fw-500'>Number of Entry</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Enter number of entry here"
                                            {...register(`team_events[${index}].number_of_participants`, {
                                                required: "Number of Entry is required"
                                            })}
                                        />
                                        {errors?.team_events?.length > 0 && errors?.team_events[index]?.number_of_participants && <ErrorText>{errors?.team_events[index]?.number_of_participants?.message}</ErrorText>}
                                    </Form.Group>
                                </Col>
                                <Col xs={6}>
                                    <Form.Group>
                                        <Form.Label className='fs-14 fw-500'>Price</Form.Label>
                                        <Form.Control
                                            type="number"
                                            placeholder="Enter price here"
                                            {...register(`team_events[${index}].price`, {
                                                required: "Price is required"
                                            })}
                                        />
                                        {errors?.team_events?.length > 0 && errors?.team_events[index]?.price && <ErrorText>{errors?.team_events[index]?.price?.message}</ErrorText>}
                                    </Form.Group>
                                </Col>
                            </Row>
                            <TeamCategory
                                teamIndex={index}
                                allWatchedValues={allWatchedValues}
                                eventTypeList={eventTypeList}
                                {...{ control, register, errors }}
                            />
                        </div>
                    );
                })}
            </div>
        }

        <Row className='my-4'>
            <span className='fs-18 fw-600 mb-3'>Tournament registration Time</span>
            <Col xs={6}>
                <Form.Group className="d-flex flex-column align-items-start">
                    <Form.Label className='text-fs-14 fw-500'>Start date</Form.Label>
                    <Controller
                        control={control}
                        name={`registration_start_date`}
                        render={({ field }) => (
                            <DatePickerWithYearAndMonth
                                {...field}
                                selected={field.value}
                                onChange={(date) => field.onChange(date)}
                                customInput={<CustomDatePicker
                                    {...field}
                                    inputRef={registrationStartDateRef}
                                />}
                            />
                        )}
                        rules={{ required: 'Registration Start date is required' }}
                    />
                    {errors.registration_start_date && <ErrorText>{errors.registration_start_date.message}</ErrorText>}
                </Form.Group>
            </Col>
            <Col xs={6}>
                <Form.Group className="d-flex flex-column align-items-start">
                    <Form.Label className='text-fs-14 fw-500'>End date</Form.Label>
                    <Controller
                        control={control}
                        name={`registration_end_date`}
                        render={({ field }) => (
                            <DatePickerWithYearAndMonth
                                {...field}
                                selected={field.value}
                                onChange={(date) => field.onChange(date)}
                                customInput={<CustomDatePicker
                                    {...field}
                                    inputRef={registrationEndDateRef}
                                />}
                            />
                        )}
                        rules={{ required: 'Registration End date is required' }}
                    />
                    {errors.registration_end_date && <ErrorText>{errors.registration_end_date.message}</ErrorText>}
                </Form.Group>
            </Col>
        </Row>

        <Row className='mb-4'>
            <span className='fs-18 fw-600 mb-3'>Tournament Time</span>
            <Col xs={6} lg={3}>
                <Form.Group className="d-flex flex-column align-items-start">
                    <Form.Label className='text-fs-14 fw-500'>Start date</Form.Label>
                    <Controller
                        control={control}
                        name={`tournament_start_date`}
                        render={({ field }) => (
                            <DatePickerWithYearAndMonth
                                {...field}
                                selected={field.value}
                                onChange={(date) => field.onChange(date)}
                                customInput={<CustomDatePicker
                                    {...field}
                                    inputRef={tournamentStartDateRef}
                                />}
                            />
                        )}
                        rules={{ required: 'Tournament Start date is required' }}
                    />
                    {errors.tournament_start_date && <ErrorText>{errors.tournament_start_date.message}</ErrorText>}
                </Form.Group>
            </Col>
            <Col xs={6} lg={3}>
                <Form.Group>
                    <Form.Label className='text-fs-14 fw-500'>Start time</Form.Label>
                    <Controller
                        control={control}
                        name={`tournament_start_time`}
                        render={({ field }) => (
                            <TimePicker
                                className='form-control'
                                onChange={field.onChange}
                                value={field.value}
                                minutePlaceholder='mm'
                                hourPlaceholder='hh'
                                format="hh:mm a"
                                openClockOnFocus={false}
                                closeClock={true}
                                disableClock={true}
                            />
                        )}
                        rules={{ required: 'Start time is required' }}
                    />
                    {errors.tournament_start_time && <ErrorText>{errors.tournament_start_time?.message}</ErrorText>}
                </Form.Group>
            </Col>
            <Col xs={6} lg={3} className='mt-3 mt-lg-0'>
                <Form.Group className="d-flex flex-column align-items-start">
                    <Form.Label className='text-fs-14 fw-500'>End date</Form.Label>
                    <Controller
                        control={control}
                        name={`tournament_end_date`}
                        render={({ field }) => (
                            <DatePickerWithYearAndMonth
                                {...field}
                                selected={field.value}
                                onChange={(date) => field.onChange(date)}
                                customInput={<CustomDatePicker
                                    {...field}
                                    inputRef={tournamentEndDateRef}
                                />}
                            />
                        )}
                        rules={{ required: 'Tournament End date is required' }}
                    />
                    {errors.tournament_end_date && <ErrorText>{errors.tournament_end_date.message}</ErrorText>}
                </Form.Group>
            </Col>
            <Col xs={6} lg={3} className='mt-3 mt-lg-0'>
                <Form.Group>
                    <Form.Label className='text-fs-14 fw-500'>End time</Form.Label>
                    <Controller
                        control={control}
                        name={`tournament_end_time`}
                        render={({ field }) => (
                            <TimePicker
                                className='form-control'
                                onChange={field.onChange}
                                value={field.value}
                                minutePlaceholder='mm'
                                hourPlaceholder='hh'
                                format="hh:mm a"
                                openClockOnFocus={false}
                                closeClock={true}
                                disableClock={true}
                            />
                        )}
                        rules={{ required: 'End time is required' }}
                    />
                    {errors.tournament_end_time && <ErrorText>{errors.tournament_end_time?.message}</ErrorText>}
                </Form.Group>
            </Col>
        </Row>
    </>
};

export default TournamentForm;